// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Modal_wrapper__3AbNz","modal":"Modal_modal__2AP-D","contentWrapper":"Modal_contentWrapper__1FNms","content":"Modal_content__3x2s4","close":"Modal_close__1D1Hf"};